<script>

import { Pie } from 'vue-chartjs';
import ColorHash from 'color-hash';

const colorHash = new ColorHash();

export default {
  extends: Pie,
  name: 'ProductUsageChart',
  props: ['elements'],
  methods: {
    roundNumber(n) {
      return Math.round(n * 100) / 100;
    },
  },
  mounted() {
    this.renderChart({
      datasets: [{
        data: this.elements.map(e => this.roundNumber(e.percentage)),
        backgroundColor: this.elements.map(e => colorHash.hex(e.name)),
        label: 'Dataset 1'
      }],
      labels: this.elements.map(e => `${e.name} (%)`),
      options: {
        labelString: '$',
      },
    });
  },
};
</script>
